import { useNetworkMonitor } from '@/hooks/useNetworkMonitor';

export const WithContext = () => {
  useNetworkMonitor();
  return <></>;
};
